import styled from 'styled-components';

export const TableRow = styled.tr`
  height: ${({ theme }) => theme.spacing[8]};
`;
